import React, { Dispatch, SetStateAction, useEffect, useState } from "react";
import styled from "styled-components";
import { isCompanyUser, useLoginContext } from "@bindeleddet/core/contexts/login";
import { NavLink, useHistory, useLocation } from "react-router-dom";
import { Badge } from "antd";
import { BellOutlined } from "@ant-design/icons";
import axios from "axios";
import { StudentNotification } from "@bindeleddet/core/types";
import LoginButton from "./LoginButton/LoginButton";
import ProfileButton from "./ProfileButton/ProfileButton";

interface UlProps {
  open: boolean;
  pathname: string;
}

const Ul = styled.ul<UlProps>`
  list-style: none;
  display: flex;
  flex-flow: row nowrap;
  white-space: nowrap;
  z-index: 140;
  li {
    display: flex;
    align-items: center;
    height: 65px;
    padding: 0 10px;
    color: ${props => (props.pathname === "/" ? "#f1f1f1" : "var(--font-color)")};
  }
  li a,
  li .ant-badge svg {
    color: ${props => (props.pathname === "/" ? "#f1f1f1" : "var(--font-color)")};
  }
  a:hover {
    font-weight: bold;
  }
  @media (max-width: 1050px) {
    flex-flow: column nowrap;
    background-color: #0d2538;
    position: fixed;
    transform: ${({ open }) => (open ? "translateX(0)" : "translateX(100%)")};
    top: 0;
    right: 0;
    height: 100vh;
    width: 300px;
    padding-top: 3.5rem;
    transition: transform 0.3s ease-in-out;
    li {
      color: #fff;
      padding: 0 40px 0 10px;
    }
    li a,
    li .ant-badge svg {
      color: #ffffff;
    }
  }
`;

interface Props {
  open: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
}

const RightNav: React.FC<Props> = ({ open, setOpen }) => {
  const [notificationCount, setNotificationCount] = useState(0);
  const { currentUser } = useLoginContext();
  const { pathname } = useLocation();
  const isCompany = isCompanyUser(currentUser);

  document.querySelectorAll("li").forEach(el => el);

  const history = useHistory();

  const handleClick = () => {
    setOpen(false);
  };

  useEffect(() => {
    if (!currentUser || isCompanyUser(currentUser)) return setNotificationCount(0);
    axios
      .get<StudentNotification[]>("/students/student-notifications/")
      .then(response => setNotificationCount(response.data.filter(notification => !notification.read_at).length));
  }, [currentUser, pathname]);

  return (
    <Ul open={open} pathname={pathname}>
      <li>
        <NavLink to="/events/" activeStyle={{ fontWeight: "bold" }} onClick={handleClick}>
          Arrangementer
        </NavLink>
      </li>
      <li>
        <NavLink to="/jobs/" activeStyle={{ fontWeight: "bold" }} onClick={handleClick}>
          Stillingsannonser
        </NavLink>
      </li>
      <li>
        <NavLink to="/companies/" activeStyle={{ fontWeight: "bold" }} onClick={handleClick}>
          Bedrifter
        </NavLink>
      </li>
      {isCompany ? (
        <li>
          <NavLink to="/company/event-booking/" activeStyle={{ fontWeight: "bold" }} onClick={handleClick}>
            Booking og priser
          </NavLink>
        </li>
      ) : (
        <>
          <li>
            <NavLink to="/casebank/" activeStyle={{ fontWeight: "bold" }} onClick={handleClick}>
              Casebank
            </NavLink>
          </li>
          <li>
            <NavLink to="/publications/" activeStyle={{ fontWeight: "bold" }} onClick={handleClick}>
              Publikasjoner
            </NavLink>
          </li>
        </>
      )}
      <li>
        <NavLink to="/about-us/" activeStyle={{ fontWeight: "bold" }} onClick={handleClick}>
          Om oss
        </NavLink>
      </li>
      <li>
        <NavLink to="/contact-us/" activeStyle={{ fontWeight: "bold" }} onClick={handleClick}>
          Kontakt
        </NavLink>
      </li>
      {currentUser ? (
        <>
          {notificationCount > 0 && !isCompanyUser(currentUser) && (
            <li>
              <Badge
                count={notificationCount}
                size="small"
                overflowCount={9}
                style={{ fontSize: "0.9em", padding: "0px 2px" }}
              >
                <BellOutlined
                  style={{ fontSize: "20px" }}
                  onClick={() => history.push("/student-profile/notifications/")}
                />
              </Badge>
            </li>
          )}
          <li>
            <ProfileButton setOpen={setOpen} />
          </li>
        </>
      ) : (
        <li>
          <LoginButton setOpen={setOpen} open={open} />
        </li>
      )}
    </Ul>
  );
};

export default RightNav;
